import React, {useEffect, useState} from 'react'

import {BeneficioImage, BeneficioItemCard, BeneficioItemsGrid, ListaBeneficioItemsWrapper} from "./StyledComponents";
import InputNumberSelector from "../../../../../components/InputNumberSelector/InputNumberSelector";
import CustomCheckBoxForCards from "../../../../../components/CustomCheckBoxForCards/CustomCheckBoxForCards";
import {ID_TODOS_OPTION_ON_DROPDOWN} from "../../../../../constants/hardCodedConstants";

const BeneficioItems = ({modalData, setModalData, formValues, KEYS}) => {
    const [currentItemsFiltered, setCurrentItemsFiltered] = useState([]);

    useEffect(() => {
        updateSetCurrentItemsFiltered(modalData.currentItems)
    }, [formValues[KEYS.IdTipoBeneficioItem], formValues[KEYS.IdUbicacionBeneficioItem]]);

    useEffect(() => {
        if (modalData?.currentItems) {
            let total = modalData?.currentItems.reduce((sum, item) => sum + (item.cantidad * item.MontoDecimal), 0);
            setModalData({...modalData, currentTotal: total})
            updateSetCurrentItemsFiltered(modalData.currentItems)
        }
    }, [modalData.currentItems]);

    const updateSetCurrentItemsFiltered = (currentItems) => {
        let filteredItems = [...currentItems];
        if (formValues[KEYS.IdTipoBeneficioItem] && formValues[KEYS.IdTipoBeneficioItem] != ID_TODOS_OPTION_ON_DROPDOWN)
            filteredItems = filteredItems.filter(item => item.IdTipoBeneficioItem === formValues[KEYS.IdTipoBeneficioItem]);
        if (formValues[KEYS.IdUbicacionBeneficioItem] && formValues[KEYS.IdUbicacionBeneficioItem] != ID_TODOS_OPTION_ON_DROPDOWN)
            filteredItems = filteredItems.filter(item => item.IdUbicacionBeneficioItem === formValues[KEYS.IdUbicacionBeneficioItem]);

        setCurrentItemsFiltered(filteredItems);
    }

    const handleChangeCheckbox = (idCampanaBeneficioItem) => {
        const rows = modalData.currentItems.map(row => {
            if (row.IdCampanaBeneficioItem === idCampanaBeneficioItem) {
                row.checked = !row.checked;
                if (row.checked === false)
                    row.cantidad = 0;
                if (row.checked === true && row.cantidad === 0)
                    row.cantidad = 1;
            }

            return {...row}
        });
        setModalData({...modalData, currentItems: rows})
    }

    const handleChangeCantidad = (newNumber, idCampanaBeneficioItem) => {
        const rows = modalData.currentItems.map(row => {
            if (row.IdCampanaBeneficioItem === idCampanaBeneficioItem) {
                row.cantidad = newNumber;
                if (newNumber > 0)
                    row.checked = true;
                if (newNumber <= 0)
                    row.checked = false;
            }

            return {...row}
        });

        setModalData({...modalData, currentItems: rows})
    }

    return (
        <>
            {modalData?.currentItems && modalData?.currentItems.length > 0 &&
                <ListaBeneficioItemsWrapper className='custom-scroll'>
                    <BeneficioItemsGrid>
                        {currentItemsFiltered.map((item, i) => (
                            <BeneficioItemCard key={item.IdCampanaBeneficioItem}
                                               mostarDetalle={item?.mostrarDetalle ?? false}>
                                <div style={{margin:'10px'}}>
                                    <CustomCheckBoxForCards checked={item.checked}
                                                            onChange={() => handleChangeCheckbox(item.IdCampanaBeneficioItem)}/>
                                </div>
                                <div style={{margin:'10px'}}>
                                    <p className="m-0 text-right">S/. {item?.MontoText}</p>
                                </div>
                                <div className="imgBeneficioItemCard" style={{marginTop:'10px'}}>
                                    <BeneficioImage src={item.ImgSrc} loading='lazy'/>
                                </div>
                                <div className="nombreBeneficioItemCard">
                                    <p className="m-0 text-center">{item?.Descripcion}</p>
                                </div>


                                <div className="d-flex justify-content-start align-items-end" style={{marginLeft:'10px'}}>
                                    <InputNumberSelector onChange={(newNumber) => {
                                        handleChangeCantidad(newNumber, item.IdCampanaBeneficioItem)
                                    }} number={item.cantidad}/>
                                </div>
                                <div className="d-flex justify-content-end align-items-end" style={{marginRight:'10px'}}>
                                    <p className="m-0 text-right"><strong>S/. {(item?.cantidad * item?.MontoDecimal)?.toFixed(2)}</strong></p>
                                </div>

                                <div className="detalleBeneficioItemCard-container">
                                    <p className="detalleBeneficioItemCard-header m-0">Ver detalle</p>
                                    <div className="detalleBeneficioItemCard-body">
                                        <div>
                                            <p>{item?.Detalle}</p>
                                        </div>
                                    </div>
                                </div>

                            </BeneficioItemCard>
                        ))}
                    </BeneficioItemsGrid>
                </ListaBeneficioItemsWrapper>
            }
        </>
    )
}

export default BeneficioItems;
